(() => {
  if (window.LSPFragranceFinderLoader) {
    window.LSPFragranceFinderLoader.initAll(document);
    return;
  }

  const resources = new Map();
  let finderPromise = null;

  function loadResource(url, stylesheet = false) {
    if (!url) return Promise.reject(new Error('Missing finder asset'));
    const absoluteUrl = new URL(url, document.baseURI).href;
    if (resources.has(absoluteUrl)) return resources.get(absoluteUrl);
    const selector = stylesheet ? 'link[rel="stylesheet"]' : 'script[src]';
    let element = [...document.querySelectorAll(selector)].find((node) => (
      (stylesheet ? node.href : node.src) === absoluteUrl
    ));
    if (element?.dataset.lspLoaded === 'true' || (stylesheet && element?.sheet)) {
      return Promise.resolve();
    }
    const promise = new Promise((resolve, reject) => {
      const created = !element;
      if (created) {
        element = document.createElement(stylesheet ? 'link' : 'script');
        if (stylesheet) {
          element.rel = 'stylesheet';
          element.href = absoluteUrl;
        } else {
          element.src = absoluteUrl;
          element.async = false;
        }
      }
      element.addEventListener('load', () => {
        element.dataset.lspLoaded = 'true';
        resolve();
      }, { once: true });
      element.addEventListener('error', () => {
        element.remove();
        reject(new Error('Finder asset failed to load'));
      }, { once: true });
      if (created) document.head.appendChild(element);
    }).catch((error) => {
      resources.delete(absoluteUrl);
      throw error;
    });
    resources.set(absoluteUrl, promise);
    return promise;
  }

  function loadFinder(root) {
    if (window.LSPFragranceFinder) {
      window.LSPFragranceFinder.initAll(document);
      return Promise.resolve();
    }
    if (!finderPromise) {
      finderPromise = Promise.all([
        loadResource(root.dataset.finderCssUrl, true),
        window.LSP_FRAGRANCE_INDEX
          ? Promise.resolve()
          : loadResource(root.dataset.finderIndexUrl),
      ])
        .then(() => loadResource(root.dataset.finderAppUrl))
        .then(() => {
          if (!window.LSPFragranceFinder) throw new Error('Finder did not initialize');
          window.LSPFragranceFinder.initAll(document);
        })
        .catch((error) => {
          finderPromise = null;
          throw error;
        });
    }
    return finderPromise;
  }

  function startFinder(root) {
    if (root.dataset.finderInitialized === 'true') return Promise.resolve();
    const status = root.querySelector('[data-finder-status]');
    root.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Cargando buscador…';
    return loadFinder(root)
      .then(() => {
        if (status?.textContent === 'Cargando buscador…') status.textContent = '';
      })
      .catch((error) => {
        if (status) status.textContent = 'No se ha podido cargar el buscador. Vuelve a intentarlo.';
        throw error;
      })
      .finally(() => root.removeAttribute('aria-busy'));
  }

  function initAll(scope = document) {
    const roots = scope.matches?.('[data-lsp-fragrance-finder]')
      ? [scope]
      : scope.querySelectorAll('[data-lsp-fragrance-finder]');
    roots.forEach((root) => {
      if (root.dataset.finderLoaderInitialized === 'true' || !root.dataset.finderAppUrl) return;
      const input = root.querySelector('[data-finder-input]');
      const form = root.querySelector('[data-finder-form]');
      if (!input || !form) return;
      root.dataset.finderLoaderInitialized = 'true';
      let pendingSubmit = false;
      const begin = () => startFinder(root).catch(() => {});
      input.addEventListener('focus', begin);
      input.addEventListener('pointerdown', begin);
      input.addEventListener('input', begin);
      form.addEventListener('submit', (event) => {
        if (root.dataset.finderInitialized === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pendingSubmit) return;
        pendingSubmit = true;
        startFinder(root)
          .then(() => form.requestSubmit())
          .catch(() => {})
          .finally(() => { pendingSubmit = false; });
      }, true);

      const modal = root.closest('details-modal.header__search');
      const details = modal?.querySelector('details');
      const toggle = modal?.querySelector('summary');
      const headerSection = modal?.closest('.section-header');
      if (details && toggle) {
        const syncHeaderLayer = () => {
          headerSection?.classList.toggle(
            'lsp-search-is-open',
            Boolean(headerSection.querySelector('details-modal.header__search details[open]')),
          );
          if (details.open) begin();
        };
        details.addEventListener('toggle', syncHeaderLayer);
        syncHeaderLayer();
        toggle.addEventListener('click', () => {
          startFinder(root).then(() => {
            window.setTimeout(() => { if (details.open) input.focus(); }, 30);
          }).catch(() => {});
        });
      }
      if (document.activeElement === input || input.value.trim()) begin();
    });
    window.LSPFragranceFinder?.initAll(scope);
  }

  window.LSPFragranceFinderLoader = { initAll, loadFinder };
  initAll(document);
  document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
